module.exports = function getResource(label, vars = []) {
    let resources = {
        curbsidePickupAvailable: 'Ramassage côté trottoir offert'
    };

    return resources[label];
};
